import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const pullQuoteFn = /* @__PURE__ */ createRecipe('pull-quote', {
  "variant": "rule"
}, [])

const pullQuoteVariantMap = {
  "variant": [
    "rule",
    "centered"
  ],
  "tone": [
    "neutral",
    "primary",
    "secondary",
    "inverse",
    "warm"
  ]
}

const pullQuoteVariantKeys = Object.keys(pullQuoteVariantMap)

export const pullQuote = /* @__PURE__ */ Object.assign(memo(pullQuoteFn.recipeFn), {
  __recipe__: true,
  __name__: 'pullQuote',
  __getCompoundVariantCss__: pullQuoteFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: pullQuoteVariantKeys,
  variantMap: pullQuoteVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, pullQuoteVariantKeys)
  },
  getVariantProps: pullQuoteFn.getVariantProps,
})